var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ3AutoManuTeleruptor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73 41a2 2 0 01-2 2H53v2h14a2 2 0 010 4H53v2h10a2 2 0 010 4H47.13a14 14 0 01-.26-28H55a2 2 0 010 4h-9v2h21a2 2 0 010 4H53v2h18a2 2 0 012 2zM49 76h20v-4H49v4zM22.14 41.26h1.42v-4h-1.15A16.56 16.56 0 1139.07 15h-4.76l7.81 8.47L49.93 15h-6.64a20.56 20.56 0 10-21.15 26.26zM49 65h-9v-7h-4v7h-9v4h22v-4zM20.86 10h4.27l7.64 20h-3.55l-1.73-5h-9.15l-1.8 5h-3.43l7.75-20zm2 3.71L19.73 22h6.36l-3.23-8.29zM7 76h20v-4H7v4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J3_Auto_manu_teleruptor.7cee4504.svg";
export { SvgJ3AutoManuTeleruptor as ReactComponent };